import { validatePhone } from "@common/components/Form/Field/lib";
import { type I18n } from "@common/lib/i18n";
import { parseSouthAfricaId } from "@common/lib/id";
import { Common } from "@common/types";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export type ValidateFn = (i18n: I18n, value: any) => Promise<string | null | undefined> | string | null | undefined;

export const fieldValidation = {
  getPrimary: (fck?: Common.System.FormControlKey): ValidateFn | null => {
    switch (fck) {
      case "Email":
        return fieldValidation.email;
      case "SouthAfricanIdNumber":
        return fieldValidation.southAfricaId;
      case "Telephone":
        return fieldValidation.telephone;
      default:
        return null;
    }
  },
  email: (i18n: I18n, value: string): string | null => (value.match(EMAIL_REGEX) ? null : i18n.errorInvalidEmail),
  southAfricaId: (i18n: I18n, value: string): string | null => {
    if (!value) return null;

    return parseSouthAfricaId(value) ? null : i18n.errorInvalidSouthAfricanIDNumber;
  },
  telephone: validatePhone
};

export type Padding = {
  paddingBottom: number | string | undefined;
  paddingLeft: number | string | undefined;
  paddingRight: number | string | undefined;
  paddingTop: number | string | undefined;
};
